// components/UI/KitcoMarketTable.jsx
import React from 'react';
import { Box, Paper, Typography, alpha, Button } from '@mui/material';
import { OpenInNew } from '@mui/icons-material';

const KitcoMarketTable = ({ height = 500 }) => {
  return (
    <Paper
      sx={{
        p: 2,
        bgcolor: '#FFFFFF',
        borderRadius: 2,
        border: `1px solid ${alpha('#D4AF37', 0.2)}`,
        overflow: 'hidden',
        height: '100%',
      }}
    >
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
        <Typography variant="h6" sx={{ color: '#0a0a2a', fontWeight: 700 }}>
          Precious Metals Live Prices
        </Typography>
        <Button 
          size="small" 
          startIcon={<OpenInNew />} 
          onClick={() => window.open('https://www.kitco.com/market/', '_blank')}
          sx={{ fontSize: '0.7rem', color: '#D4AF37' }}
        >
          View on Kitco
        </Button>
      </Box>
      
      <Box
        component="iframe"
        src="https://www.kitco.com/market/"
        sx={{
          width: '100%',
          height: height,
          border: 'none',
          borderRadius: 1,
          bgcolor: '#FFFFFF',
        }}
        title="Kitco Market Data"
      />
    </Paper>
  );
};

export default KitcoMarketTable;